export const PRIORITY_BY_MODE_KEY = 'priorityOrderByMode';
